const Space = () => {
  return <div style={{ height: 10 }}></div>;
};

export { Space };
